// extracted by mini-css-extract-plugin
export default {"my_empty":"MyEmpty_my_empty__D3vyx","my_empty_image":"MyEmpty_my_empty_image__DRzjN","archived":"MyEmpty_archived__-VzSn"};